import { object, string } from 'yup';
const passwordRecoveryValidation = object().shape({
  password: string().required('validations.password.required'),
  confirmPassword: string().required('validations.confirm_password.required').test('password-should-match', 'validations.password.not_matching', function (value) {
    return this.parent.password === value;
  })
});
export default passwordRecoveryValidation;